import { FC, useState } from "react";

import { Button } from "@/components/_ui/button";
import { useCheckPermission } from "@/domain/_shared/permission/hooks/api/use-check-permission";
import { Workspace } from "@/domain/workspace/models/workspace-model";

import { LabelCreateForm } from "./label-create-form";
import { LabelGroupCreateForm } from "./label-group-create-form";
import { LabelGroupList } from "./label-group-list";
import { LabelList } from "./label-list";

export interface LabelSettingsTableProps {
  workspace: Workspace;
}

export const LabelSettingsTable: FC<LabelSettingsTableProps> = ({ workspace }) => {
  const { hasPermission: hasPermissionToManageWorkspace } = useCheckPermission({
    resource: "workspace",
    resourceId: workspace.id,
    action: "manage",
  });
  const [showCreateLabel, setShowCreateLabel] = useState(false);
  const [showCreateLabelGroup, setShowCreateLabelGroup] = useState(false);

  return (
    <div>
      <div>
        <p className="font-light text-muted-foreground">
          Verwenden Sie Label und Gruppen von Label, um Maßnahmen in Ihrem Workspace zu organisieren und zu filtern. Die
          in diesem Abschnitt erstellten Label sind für alle Teams des Workspaces verfügbar.
        </p>
        <div className="my-8"></div>
        {hasPermissionToManageWorkspace && (
          <div className="flex shrink grow flex-row items-center justify-end gap-3">
            <div className="flex flex-row gap-6"></div>
            <Button
              size="xs"
              variant="outline"
              disabled={showCreateLabel || showCreateLabelGroup}
              onClick={() => {
                setShowCreateLabelGroup(true);
              }}
            >
              Neue Gruppe
            </Button>
            <Button
              size="xs"
              variant="default"
              disabled={showCreateLabel || showCreateLabelGroup}
              onClick={() => {
                setShowCreateLabel(true);
              }}
            >
              Neues Label
            </Button>
          </div>
        )}
      </div>
      <div className="mt-10">
        {showCreateLabel && (
          <LabelCreateForm
            workspace={workspace}
            onCanceled={() => {
              setShowCreateLabel(false);
            }}
            onSuccess={() => {
              setShowCreateLabel(false);
            }}
          />
        )}
        {showCreateLabelGroup && (
          <LabelGroupCreateForm
            workspace={workspace}
            onCanceled={() => {
              setShowCreateLabelGroup(false);
            }}
            onSuccess={() => {
              setShowCreateLabelGroup(false);
            }}
          />
        )}
        <LabelGroupList workspace={workspace} />
        <LabelList workspace={workspace} />
      </div>
    </div>
  );
};
